/** @module csi/form/Tooltip */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/heading/_base",
	"csi/html",
	"csi/locale",
	"csi/view/Tooltip",
	"csi/xml"
], function(declare, lang, _, def, Action, Field, csiHeading, html, locale, Tooltip, xml) {

	return declare(Tooltip, {
		/** @property {boolean} bOnHover - if true then view case, otherwise it's form case */
		bOnHover: false,

		/**
		 * @override
		 * Generate custom tooltip for form fields
		 */
		generateTooltipFor: async function(params) {
			if (!params) {
				return;
			}

			const {ctx, field} = params;
			if (!field) {
				return;
			}

			const {
				bDisableExpressionEvaluation,
				m_control,
				heading,
				startedWithDisabledContinuousExpression,
			} = field;

			// add tooltip message
			let multiLineText = "";

			if (heading?.m_tooltip) {
				multiLineText = heading.m_tooltip;
			}

			if (m_control?.promptMessage) {
				if (multiLineText) {
					multiLineText += "\n";
				}

				multiLineText += m_control.promptMessage;
			}

			if (multiLineText) {
				this.addContent(html.create("div", {multiLineText}));
			}

			// add content for tooltip expression if expression is not disabled
			if (this.view.getFieldExpression(field) && (!bDisableExpressionEvaluation || startedWithDisabledContinuousExpression)) {
				this.view._evaluateExpression(ctx, field, this);
			}
		},

		/**
		 * Update field tooltip depending on if expression value is same as field value
		 * @param {Context} ctx
		 * @param {Field} field
		 * @param {Node} node
		 * @param {any} value
		 */
		onFieldExpressionValue(ctx, field, node, value) {
			const {
				bDisableExpressionEvaluation,
				m_format,
				heading,
				ren,
				startedWithDisabledContinuousExpression,
				m_type,
				m_typeControl,
			} = field;

			let idRes;

			if (value == null) {
				value = "";
			}

			if (field.isDefaultValue(value) && (!startedWithDisabledContinuousExpression || !bDisableExpressionEvaluation)) {
				// expression is active and could be disabled
				idRes = "ActionAttribute_Exp";
			} else {
				// expression is disabled and could be restored
				idRes = "ActionAttribute_ExpOver";

				// render what value would be if restored
				const id = heading.m_id;
				const previousValue = node[id];

				xml.nodeAttributeSetValue(node, id, value);

				// if renderer is not defined, get the default renderer based on the typeControl
				const resolvedRenderer = ren || Field.getRendererForControl(heading, m_typeControl, m_type, m_format);
				if (resolvedRenderer) {
					csiHeading.addRestoreExpressionToTooltip(this, ctx, heading, resolvedRenderer);
				}

				xml.nodeAttributeSetValue(node, id, previousValue);

				// add action to restore expression
				const action = lang.mixin(new Action(), {
					m_name: locale.resource("RestoreExpression"),
					m_id: "FormRestoreExpression",
					m_typeControl: def.ACTION_LINK,
					m_onAction: function(ac) {
						ac.widget.setFieldValue(field, value);
						field.bDisableExpressionEvaluation = false;
					}
				});
				action.heading = heading;
				action.resolve();
				this.addAction(action);
			}

			if (idRes) {
				this.addContent(html.create("div", {
					innerText: locale.resource(idRes)
				}));
			}
		}
	});
});